/*
* To have dynamic panes and pass random content to it, CustomMuiAccordion element has
* to follow specific markup for its Panes labels and data.
*
* See example in stories.
*
* Attributes like "panes, cols, skipData" mostly relate to rendering of data on
* Drupal side. "skipData" indicates to not try to render REST view in Drupal, if
* set to TRUE.
*
* */
import React, {useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Remove from '@mui/icons-material/Remove';
import Add from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import {parseGutenbergReact} from "@/api/global";

const useStyles = makeStyles((theme) => ({
    IncAccord: {
      width: '100%',
      "& svg": {
        color: theme.palette.grey[400],
      }
    },
    IncAccordInner: {
      flexGrow: 1,
      '& p': {
        fontSize: '18px',
      },
    },
    IncAccordLbl: {
      fontSize: theme.typography.pxToRem(18),
      flexBasis: '100%',
      flexShrink: 0,
      color: theme.palette.grey[600],
      fontWeight: 700,
      margin: 0,
    },
    IncAccordStyle: {
      backgroundColor: props => (props.bgColor) ? `${props.bgColor}` : theme.palette.grey[300],
      boxShadow: 'none',
      marginBottom: '7px',
      '&:before': {
        content: 'none'
      }
    }
  }),
);

export default function Accordions(props) {
  let {children, panes, cols, skipData, block, bgColor, openFirst} = props;

  if ((!cols || !children) && block?.data) {
    cols = !cols ? block?.data.cols : cols;
  }
  else if (block?.para?.length > 0) {
    cols = block.para;
  }
  if (!cols && !children) {
    return null;
  }

  const classes = useStyles(props);
  const [expanded, setExpanded] = useState(openFirst ? `panel1` : false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  let i = 0;
  return (
      <Box py={4}>
        <Grid container>
        <Grid item xs={12}>
          <div className={classes.IncAccordInner}>

            {/* For content from DRUPAL PARAGRAPHS widgets: */}
            {block?.para?.length > 0 &&
              <>
                {
                  block.para.map((val, ind) => {
                    let repl_sec = val.second.replace('="/sites/default/files', `="${process.env.NEXT_PUBLIC_DRUPAL_BASE_URL}/sites/default/files`);
                    let body = (
                      <AccordionDetails key={`det-${val.key}-${ind}`}>
                        <Typography component={`div`}>
                          <div dangerouslySetInnerHTML={{__html: repl_sec}}></div>
                        </Typography>
                      </AccordionDetails>
                    );
                    const out = (
                      <Accordion key={`acc-${val.key}-${ind}`} expanded={expanded === `panel${ind}`} onChange={handleChange(`panel${ind}`)} className={classes.IncAccordStyle}>
                        <AccordionSummary
                              expandIcon={expanded === `panel${ind}`?<Remove />:<Add/>}
                              aria-controls={`panel${ind}bh-content`}
                              id={`panel${ind}bh-header`}
                              className={'accordion-wrapper'}>
                          <Typography component={`div`} className={classes.IncAccordLbl}>{val.first}</Typography>
                        </AccordionSummary>
                        {body &&
                          <>{body}</>
                        }
                      </Accordion>
                    );
                    return out;
                  })
                }
              </>
            }

            {/* For content when data is provided as children elements within: */}
            {!block?.para &&
              <>
                {cols && cols.map((val, ind) => {
                  let body = (
                    <AccordionDetails key={`det-${val.key}-${ind}`}>
                      <Typography component={`div`}>
                        {val.data.map((gb, igb) => {
                          return parseGutenbergReact(`inner-${igb}`, gb, skipData);
                        })
                        }
                      </Typography>
                    </AccordionDetails>
                  );
                  const out = (
                    <Accordion key={`acc-${val.key}-${ind}`} expanded={expanded === `panel${ind}`} onChange={handleChange(`panel${ind}`)}>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls={`panel${ind}bh-content`} id={`panel${ind}bh-header`}>
                        <Typography component={`div`} className={classes.IncAccordLbl}>{val.attrs.label}</Typography>
                      </AccordionSummary>
                      {body &&
                      <>
                        {body}
                      </>
                      }
                    </Accordion>
                  );
                  return out;
                })}

                {children && children.map((val, ind) => {
                  let body = null;

                  if (val.key?.includes('acc-lbl-')) {
                    if (children[ind+1] && children[ind+1].key?.includes(`acc-data-${i+1}`)) {
                      body = (
                        <AccordionDetails key={`det-${val.key}-${ind}`} className={children[ind+1]?.props?.className || ''}>
                          <Typography component={`section`} className={classes.IncAccordInner}>
                            {children[ind+1]}
                          </Typography>
                        </AccordionDetails>
                      );
                      i += 1;
                    }
                    const out = (
                      <Accordion key={`acc-${val.key}-${ind}`} expanded={expanded === `panel${i}`} onChange={handleChange(`panel${i}`)} className={`${classes.IncAccordStyle} ${val?.props?.className || ''}`}>
                        <AccordionSummary
                          expandIcon={expanded === `panel${i}`?<Remove />:<Add/>}
                          aria-controls={`panel${i}bh-content`}
                          id={`panel${i}bh-header`}
                        >
                          <Typography component={`div`} className={classes.IncAccordLbl}>{val.props?.children}</Typography>
                        </AccordionSummary>
                        {body}
                      </Accordion>
                    );
                    return out;
                  }
                })
                }
              </>
            }
          </div>
        </Grid>
      </Grid>
      </Box>
  );
}
